import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const featuredItems = [{
  name: 'Tacos Auténticos',
  price: '$3.00',
  desc: 'Asada, Pastor, o Pollo. Servidos con cilantro y cebolla.',
  img: 'https://cdn.magicpatterns.com/uploads/cSDwDEAWcHuNBgyp3rN3gf/ChatGPT_Image_22_may_2026,_09_07_49_p.m..png'
}, {
  name: 'Burritos Clásicos',
  price: '$8.00',
  desc: 'Rellenos de tu carne favorita y arroz. Sabor en cada bocado.',
  img: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?auto=format&fit=crop&q=80&w=800'
}, {
  name: 'Quesadillas',
  price: '$7.00',
  desc: 'Queso derretido con Asada, Pollo, Pastor o Tinga. Servidas con arroz.',
  img: 'https://images.unsplash.com/photo-1615870216519-2f9fa575fa5c?auto=format&fit=crop&q=80&w=800'
}, {
  name: 'Aguas Frescas',
  price: '$2.50',
  desc: 'Refrescantes y naturales. El acompañamiento perfecto.',
  img: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&q=80&w=800'
}];
const menuCategories = [{
  title: 'Antojitos',
  items: [{
    name: 'Tacos',
    price: '$3.00',
    options: ['Asada / Steak', 'Pastor', 'Pollo / Chicken'],
    servedWith: 'cilantro, onion'
  }, {
    name: 'Sopes',
    price: '$4.50',
    options: ['Asada / Steak', 'Pastor', 'Tinga', 'Pollo / Chicken'],
    servedWith: 'lettuce, cream cheese'
  }, {
    name: 'Tostadas',
    price: '$3.00',
    options: ['Tinga', 'Pollo / Chicken'],
    servedWith: 'lettuce, cream cheese'
  }, {
    name: 'Flautas',
    price: '5 for $10',
    options: ['Pollo / Chicken'],
    servedWith: 'lettuce, cream cheese'
  }, {
    name: 'Huaraches',
    price: '$8.00',
    options: ['Asada / Steak', 'Pollo / Chicken', 'Pastor', 'Tinga'],
    servedWith: 'lettuce, cream cheese'
  }, {
    name: 'Burritos',
    price: '$8.00',
    options: ['Asada / Steak', 'Pollo / Chicken', 'Tinga', 'Pastor'],
    servedWith: 'rice'
  }, {
    name: 'Quesadillas',
    price: '$7.00',
    options: ['Asada / Steak', 'Pollo / Chicken', 'Pastor', 'Tinga'],
    servedWith: 'rice'
  }]
}, {
  title: 'Especialidades de la Casa',
  items: [{
    name: 'The Happy Plate',
    price: '$17.99',
    desc: 'Grilled steak, fried chicken, 6 shrimp, bell pepper, onion',
    servedWith: 'rice and beans'
  }, {
    name: 'Carne Asada / Grilled Steak',
    price: '$14.50',
    servedWith: 'rice, beans, tortillas'
  }, {
    name: 'Pollo Asado',
    price: '$12.00',
    servedWith: 'rice, beans, tortillas'
  }, {
    name: 'Chori Pollo',
    price: '$13.99',
    desc: 'Grilled chicken breast covered with melted cheese',
    servedWith: 'rice, beans, tortillas'
  }]
}, {
  title: 'Fajitas',
  items: [{
    name: 'Chicken Fajitas',
    price: '$12.99',
    desc: 'Chicken, onion, bell pepper',
    servedWith: 'rice, beans, tortillas'
  }, {
    name: 'Fajitas Steak & Chicken',
    price: '$14.99',
    servedWith: 'rice, beans, tortillas'
  }, {
    name: 'Fajitas Mixed',
    price: '$16.99',
    desc: 'Chicken, steak, shrimp, bell pepper, onion',
    servedWith: 'rice, beans, tortillas'
  }]
}, {
  title: 'American Classics & Bebidas',
  items: [{
    name: 'Burger',
    price: '',
    desc: 'Cheese, lettuce, tomato, onion',
    servedWith: 'fries'
  }, {
    name: 'Hot Dog',
    price: '',
    desc: 'Chili, onion',
    servedWith: 'fries'
  }, {
    name: 'Aguas Frescas',
    price: '$2.50',
    options: [],
    servedWith: ''
  }, {
    name: 'Sodas / Soft Drink',
    price: '',
    options: [],
    servedWith: ''
  }]
}];
function MenuItem({
  item
}: {
  item: any;
}) {
  return <div className="mb-6 last:mb-0" data-id="element-145">
      <div className="flex items-baseline justify-between mb-1" data-id="element-146">
        <h4 className="font-display font-bold text-xl text-burgundy-dark tracking-wide" data-id="element-147">
          {item.name}
        </h4>
        <div className="flex-grow border-b-2 border-dotted border-burgundy/20 mx-4 relative top-[-6px]" data-id="element-148"></div>
        <span className="font-display font-bold text-lg text-orange" data-id="element-149">
          {item.price}
        </span>
      </div>

      {item.desc && <p className="text-charcoal/70 text-sm mb-1" data-id="element-150">{item.desc}</p>}

      {item.options && item.options.length > 0 && <div className="flex flex-wrap gap-2 mt-2 mb-1" data-id="element-151">
          {item.options.map((opt: string, i: number) => <span key={i} className="text-xs font-medium bg-cream-alt px-2 py-1 rounded text-burgundy/80 uppercase tracking-wider" data-id="element-152">
              {opt}
            </span>)}
        </div>}

      {item.servedWith && <p className="text-charcoal/50 text-sm italic mt-1" data-id="element-153">
          Served with: {item.servedWith}
        </p>}
    </div>;
}
export function Menu() {
  return <section id="menu" className="py-24 md:py-32 bg-cream-alt" data-id="element-154">
      <div className="max-w-7xl mx-auto px-6" data-id="element-155">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-24" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-157">
            <span className="text-orange font-bold tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-158">
              Descubre
            </span>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-coral mb-6" data-id="element-159">
              NUESTRO MENÚ
            </h2>
            <p className="font-script text-3xl text-charcoal/70 max-w-2xl mx-auto" data-id="element-160">
              Hecho con ingredientes frescos cada día.
            </p>
          </motion.div>
        </div>

        {/* Featured Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-161">
          {featuredItems.map((item, index) => <motion.div key={item.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-cream rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-burgundy/5" data-id="element-162">
              <div className="relative h-48 overflow-hidden" data-id="element-163">
                <img src={item.img} alt={item.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-164" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-165" />
              </div>
              <div className="p-6 relative" data-id="element-166">
                <div className="flex justify-between items-start mb-2" data-id="element-167">
                  <h3 className="font-display font-bold text-xl text-burgundy-dark" data-id="element-168">
                    {item.name}
                  </h3>
                  <span className="font-bold text-orange" data-id="element-169">{item.price}</span>
                </div>
                <p className="text-charcoal/70 text-sm leading-relaxed" data-id="element-170">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Full Menu Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-171">
          {menuCategories.map((category, idx) => <motion.div key={category.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="bg-cream p-8 md:p-10 rounded-3xl shadow-sm border border-burgundy/5" data-id="element-172">
              <h3 className="font-display text-3xl text-coral text-center mb-10 pb-4 border-b border-orange/20" data-id="element-173">
                {category.title}
              </h3>
              <div data-id="element-174">
                {category.items.map((item, itemIdx) => <MenuItem key={itemIdx} item={item} data-id="element-175" />)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}